import axios from "axios";
import { loginHrefWithReturn } from "../lib/returnAfterLogin";

axios.defaults.withCredentials = true;

/** Один спільний refresh: усі 401 чекають той самий запит, потім кожен повторює свій config (без гонки subscriber vs cookie). */
let refreshPromise = null;

axios.interceptors.response.use(
    res => res,
    async error => {
        const originalRequest = error.config;
        const url = originalRequest?.url || "";

        if (
            url.includes("/api/auth/login") ||
            url.includes("/api/auth/logout") ||
            url.includes("/api/auth/refresh")
        ) {
            return Promise.reject(error);
        }

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                if (!refreshPromise) {
                    refreshPromise = axios
                        .get("/api/auth/refresh", { withCredentials: true })
                        .finally(() => {
                            refreshPromise = null;
                        });
                }
                await refreshPromise;
                return axios(originalRequest);
            } catch (refreshErr) {
                const path = window.location.pathname;
                const publicAuthPaths = ["/login", "/register"];
                if (!publicAuthPaths.includes(path)) {
                    window.location.href = loginHrefWithReturn(
                        window.location.pathname + window.location.search
                    );
                }

                return Promise.reject(refreshErr);
            }
        }

        return Promise.reject(error);
    }
);
